export enum UserType {
  LITE = 1,
  PRO = 2,
}